import UI from "../core/ui"

import { makeType, parseOptions, initLog } from "../core/base"

import { maybe, getWith } from "../core/functions"


const proto = {
    name: "Shutter",

    parseOptions,
    initLog,
    options: {},

    initialize(dom) {
        this.dom = dom
        this.initLog ()
        // this.log.enable();
        this.parseOptions ()
        this.dom.addClass ("shutter")

        // should get element by role: shutter-control
        const head = this.dom.getElement ("header")
        if (head) {
            const ctx = this
            head.addEventListener ("click", () => {
                ctx.toggle ()
            })
        }
    },

    toggle() {
        if (this.dom.hasClass ("shuttered")) {
            this.open ()
        } else {
            this.close ()
        }
    },

    open() {
        this.dom.removeClass ("shuttered")
        this.dom.addClass ("unshuttered")

        maybe ((dom, attrs) => {
          attrs.class = dom.className
        }) (getWith ("dom") (this), getWith ("dom", "component", "attrs") (this))

        // if (this.dom.component) {
        //     this.dom.component.attrs.class = this.dom.className
        // }
    },

    close() {
        this.dom.removeClass ("unshuttered")
        this.dom.addClass ("shuttered")

        maybe ((dom, attrs) => {
          attrs.class = dom.className
        }) (getWith ("dom") (this), getWith ("dom", "component", "attrs") (this))

        // if (this.dom.component) {
        //     this.dom.component.attrs.class = this.dom.className
        // }
    }
}

const Shutter = makeType (proto)

UI.register ("shutter", Shutter)
